<template>
  <li v-if="allowed(page)"
    class="text-sm"
    @click.stop="page.children && $emit('toggle-active')"
    :class="{ 'has-submenu': page.children, 'last-elements': page.last, 'active': page.active }">
    <router-link :to="page.path" v-if="!page.children" class="flex items-center h-full" @click.native="$EventBus.$emit('reset-top-menu')">
      <i :class="[ page.icon, {'mr-1': page.title} ]"></i>
      <span>{{ page.title }}</span>
    </router-link>

    <template v-else>
      <a class="select-none flex items-center justify-between h-full">
        <p>
          <i :class="page.icon" class="mr-1"></i>
          <span>{{ page.title }}</span>
        </p>
        <i class="fas fa-chevron-down toggle"></i>
      </a>
      <ul class="sub">
        <top-menu-list-item @toggle-active="toggleActive(i)" :page="page" v-for="(page, i) in page.children" :key="'page-'+i"></top-menu-list-item>
      </ul>
    </template>

  </li>
</template>

<script>
const TopMenuListItem = resolve => require(['@/components/layout/TopMenuListItem'], resolve)

export default {
  name: 'top-menu-list-item',
  props: {
    page: {}
  },
  components: {
    TopMenuListItem,
  },
  data() {
    return {
      cached: []
    }
  },
  methods: {
    toggleActive(index) {
      this.$set(this.page.children[index], 'active', !this.page.children[index].active)
    },
    allowed(page) {
      if (page.children && page.children.length) {
        return this._check(page.children.map(c => c.route))
      }
      return this._check(page.route)
    },
    _check(arg) {
      if (Array.isArray(arg)) {
        for (let i in arg) {
          if (!this.cached[arg[i]]) {
            this.$set(this.cached, arg[i], this.$checkRouteAllowed(this.$router.resolve({name: arg[i]}).route))
          }
          return this.cached[arg[i]]
        }
        return false
      }
      if (!this.cached[arg]) {
        this.$set(this.cached, arg, this.$checkRouteAllowed(this.$router.resolve({name: arg}).route))
      }
      return this.cached[arg]
    }
  }
}
</script>
